module.exports = __webpack_public_path__ + "static/balor_mtg_clb-988ef21b05a128916c76e9cba9a00b6a.jpg";